export default __webpack_public_path__ + "static/media/stopButton.c5d56e15.svg";